import React from 'react';
import { Page } from '../../../../../shared/Components/Page';
import {DescargarPlantillaContainer} from './Screen';

export const DescargarPlantillaView = () =>{

    return (
        <Page title={'Gestion DNs - Descargar Plantilla'} scrollBody>{<DescargarPlantillaContainer />}</Page>
    )
}